/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'MEDICAL_FACILITIES_CLINIC_S_ARE_PROVIDED_WITH_SUPPLIES_AND_EQUI',
              'MEDICAL_FACILITIES_CLINICS_ARE_KEPT_CLEAN_AND_SANITARY',
              'MEDICAL_FACILITIES_CLINICS_ARE_IN_OPERATION_DURING_ALL_WORKING_',
              'MEDICAL_FACILITIES_CLINIC_S_HAVE_AN_APPOINTED_DOCTOR_NURSE',
              'MEDICAL_FACILITIES_CLINIC_S_ARE_EQUIPPED_FOR_MATERNAL_HEALTHCAR',
              'MEDICINES_STORED_IN_MEDICAL_FACILITIES_CLINICS_ARE_KEPT_UNDER_L',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_measures_in_place_relate_2: valueSchema,
  },
}
